/**
 * Copyright Mántum All Rights Reserved.
 */
import Component from './component';
import Validator from '../validator';
import useEmpty from '../../../hooks/useEmpty';
import { EVENT_CLEAR, ACTION_VALUE, useGroupDispatch } from '../../group';
import { forwardRef, useRef, useImperativeHandle } from 'react';

import type { Detail } from '@mantum/kanela';
import type { PropTypes } from './component';

export default forwardRef<Detail<unknown>, PropTypes>(
    function Radio(props, ref) {
        // prettier-ignore
        const { 
        error = false,
        name,
        optional = true
    } = props;

        const empty = useEmpty(optional);
        const dispatch = useGroupDispatch();
        const inputRef = useRef<HTMLDivElement>(null);

        useImperativeHandle(
            ref,
            () => {
                return {
                    name,
                    validable: !optional,
                    clear() {
                        empty.clear();
                        if (name) {
                            dispatch({
                                type: EVENT_CLEAR,
                                content: [
                                    {
                                        action: ACTION_VALUE,
                                        target: name
                                    }
                                ]
                            });
                        }
                    },
                    validate() {
                        const target = inputRef.current;
                        return empty.validate(target?.dataset?.value);
                    },
                    value() {
                        const target = inputRef.current;
                        if (target) {
                            return target.dataset.value;
                        }
                        return null;
                    }
                };
            },
            [name, optional, empty, dispatch]
        );

        return (
            <Validator error={empty.value || error} type='radio'>
                <Component
                    {...props}
                    error={empty.value || error}
                    ref={inputRef}
                />
            </Validator>
        );
    }
);
